import React, {Component} from 'react';
import {connect} from 'react-redux';
import Swal from 'sweetalert2';
import { withNamespaces } from 'react-i18next';
import Auxiliary from "../../../hoc/Auxiliary/Auxiliary";
import axios from "../../../common/config/axios";
import * as moment from "moment";

import { getMemberPayoutSummaryReport } from "../../../store/ducks/report/actions";
import { getFilterData } from "../../../store/ducks/gameList/actions";
import { filterErrorHandler } from "../../../hoc/Shared/utility";

import MemberPayoutReportSummaryListing from "./MemberPayoutReportSummaryListing";


const initialInputState =
{
    /* form input value */
    date: '',
    start_date: '',
    end_date: '',
    start_month: '',
    end_month: '',
    start_year: '',
    end_year: '',
    date_filter: '',
};

class MemberPayoutSummaryReport extends Component {

    state = {
        pageShow: "listing",

        activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
        limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
        totalPages: 0,
        totalRecords: 0,
        order: '',

        data: [],
        sum_promo_bonus: 0,
        sum_rebate_bonus: 0,
        sum_up_level_bonus: 0,
        sum_vip_weekly_bonus: 0,
        sum_birthday_bonus: 0,
        sum_gold_digger_bonus: 0,
        sum_daily_mission_bonus: 0,
        sum_subtotal: 0,
        sum_rescue_bonus: 0,
        sum_lucky_spin_bonus: 0,
        sum_tournament_bonus: 0,
        sum_voucher_code: 0,
        sum_first_bet_bonus: 0,
        sum_business_account_reward: 0,
        sum_stakings: 0,
        sum_delay_bonus: 0,
        sum_world_cup_event_bonus: 0,
        sum_member_referral_bonus: 0,
        sum_agent_payout_bonus: 0,
        sum_mall_reward_bonus: 0,
        sum_angbao_bonus: 0,
        sum_mobile_apps_bonus: 0,
        sum_fifa_bonus: 0,
        sum_welcome_bonus: 0,
        sum_daily_bonus: 0,
        sum_accumulate_bonus: 0,
        sum_daily_check_in_bonus: 0,
        sum_instant_rebate_bonus: 0,

        loading: true,
        hideColumn: false,
        dateFilter : '',

        permission: [],
        filter: initialInputState,
        asyncSelectedVal: null,
    }

    componentDidMount() {
        this.props.getFilterData();
        this.refreshHandler();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            // let reportPermission = this.props.currentPermission.filter((item) => item.includes("report_"));
            this.setState({permission: this.props.currentPermission});
        }

        if (nextProps.reportData !== this.props.reportData) {
            if (nextProps.reportData.data && nextProps.reportData.data.responseCode === 200) {
                let multiple_totals = nextProps.reportData.data.data.multiple_totals;
                this.setState({
                    data: nextProps.reportData.data.data.result.row,
                    totalRecords: nextProps.reportData.data.data.result.pagination.total_record,
                    totalPages: nextProps.reportData.data.data.result.pagination.total_page,
                    loading: false,
                    hideColumn: (nextState.filter.date_filter === 'monthly' || nextState.filter.date_filter === 'yearly') ? true : false,
                    dateFilter: nextState.filter.date_filter,
                    sum_promo_bonus: multiple_totals[0]!==undefined ? multiple_totals[0] : 0,
                    sum_rebate_bonus: multiple_totals[1]!==undefined ? multiple_totals[1] : 0,
                    sum_up_level_bonus: multiple_totals[2]!==undefined ? multiple_totals[2] : 0,
                    sum_vip_weekly_bonus: multiple_totals[3]!==undefined ? multiple_totals[3] : 0,
                    sum_birthday_bonus: multiple_totals[4]!==undefined ? multiple_totals[4] : 0,
                    sum_gold_digger_bonus: multiple_totals[5]!==undefined ? multiple_totals[5] : 0,
                    sum_daily_mission_bonus: multiple_totals[6]!==undefined ? multiple_totals[6] : 0,
                    sum_subtotal: multiple_totals[7]!==undefined ? multiple_totals[7] : 0,
                    sum_rescue_bonus: multiple_totals[8]!==undefined ? multiple_totals[8] : 0,
                    sum_lucky_spin_bonus: multiple_totals[9]!==undefined ? multiple_totals[9] : 0,
                    sum_tournament_bonus: multiple_totals[10]!==undefined ? multiple_totals[10] : 0,
                    sum_voucher_code: multiple_totals[11]!==undefined ? multiple_totals[11] : 0,
                    sum_first_bet_bonus: multiple_totals[12]!==undefined ? multiple_totals[12] : 0,
                    sum_business_account_reward: multiple_totals[13]!==undefined ? multiple_totals[13] : 0,
                    sum_stakings: multiple_totals[14]!==undefined ? multiple_totals[14] : 0,
                    sum_delay_bonus: multiple_totals[15]!==undefined ? multiple_totals[15] : 0,
                    sum_world_cup_event_bonus: multiple_totals[16]!==undefined ? multiple_totals[16] : 0,
                    sum_member_referral_bonus: multiple_totals[17]!==undefined ? multiple_totals[17] : 0,
                    sum_agent_payout_bonus: multiple_totals[18]!==undefined ? multiple_totals[18] : 0,
                    sum_mall_reward_bonus: multiple_totals[19]!==undefined ? multiple_totals[19] : 0,
                    sum_angbao_bonus: multiple_totals[20]!==undefined ? multiple_totals[20] : 0,
                    sum_mobile_apps_bonus: multiple_totals[21]!==undefined ? multiple_totals[21] : 0,
                    sum_fifa_bonus: multiple_totals[22]!==undefined ? multiple_totals[22] : 0,
                    sum_welcome_bonus: multiple_totals[23]!==undefined ? multiple_totals[23] : 0,
                    sum_daily_bonus: multiple_totals[24]!==undefined ? multiple_totals[24] : 0,
                    sum_accumulate_bonus: multiple_totals[25]!==undefined ? multiple_totals[25] : 0,
                    sum_daily_check_in_bonus: multiple_totals[26]!==undefined ? multiple_totals[26] : 0,
                    sum_instant_rebate_bonus: multiple_totals[27]!==undefined ? multiple_totals[27] : 0,
                });
            }
            else {
                this.setState({
                    loading: false,
                    totalPages: 0,
                    activePage: 1,
                    totalRecords: 0,
                    sum_promo_bonus: 0,
                    sum_rebate_bonus: 0,
                    sum_up_level_bonus: 0,
                    sum_vip_weekly_bonus: 0,
                    sum_birthday_bonus: 0,
                    sum_gold_digger_bonus: 0,
                    sum_daily_mission_bonus: 0,
                    sum_subtotal: 0,
                    sum_rescue_bonus: 0,
                    sum_lucky_spin_bonus: 0,
                    sum_tournament_bonus: 0,
                    sum_voucher_code: 0,
                    sum_first_bet_bonus: 0,
                    sum_business_account_reward: 0,
                    sum_stakings: 0,
                    sum_delay_bonus: 0,
                    sum_world_cup_event_bonus: 0,
                    sum_member_referral_bonus: 0,
                    sum_agent_payout_bonus: 0,
                    sum_mall_reward_bonus: 0,
                    sum_angbao_bonus: 0,
                    sum_mobile_apps_bonus: 0,
                    sum_fifa_bonus: 0,
                    sum_welcome_bonus: 0,
                    sum_daily_bonus: 0,
                    sum_accumulate_bonus: 0,
                    sum_daily_check_in_bonus: 0,
                    sum_instant_rebate_bonus: 0,
                    data: [],
                }, () => 
                {
                    filterErrorHandler(nextProps.reportData.data.message);
                });
            }
        }

        return true;
    }

    onInputChange(event, picker) {
        // console.log(event.target.id+' | '+event.target.value+' | '+event.target.className);
        let newFilter = Object.assign({}, this.state.filter);
        newFilter[event.target.id] = event.target.value;

        if(event.target.id==='date') {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0].replace(/\//g, "-").toString() : '';
            newFilter['end_date'] = (date) ? date[1].replace(/\//g, "-").toString() : '';
            newFilter['start_month'] = '';
            newFilter['end_month'] = '';
            newFilter['start_year'] = '';
            newFilter['end_year'] = '';
            newFilter['date_filter'] = 'daily';
        }

        if(event.target.className.includes("monthly")) {
            newFilter['start_month'] = moment(picker.startDate).format("YYYY-MM");
            newFilter['end_month'] = moment(picker.endDate).format("YYYY-MM");
            newFilter['date'] = '';
            newFilter['start_date'] = '';
            newFilter['end_date'] = '';
            newFilter['start_year'] = '';
            newFilter['end_year'] = '';
            newFilter['date_filter'] = 'monthly';
        }

        if(event.target.className.includes("yearly")) {
            newFilter['start_year'] = moment(picker.startDate).format("YYYY");
            newFilter['end_year'] = moment(picker.endDate).format("YYYY");
            newFilter['date'] = '';
            newFilter['start_date'] = '';
            newFilter['end_date'] = '';
            newFilter['start_month'] = '';
            newFilter['end_month'] = '';
            newFilter['date_filter'] = 'yearly';
        }

        this.setState({
            filter: newFilter,
        });
    }

    onInputChangeAsync = (event, id) =>
    {
        // console.log(event);
        let newVal = (event) ? event.id : '';
        let newFilter = Object.assign({}, this.state.filter);

        newFilter[id] = newVal;

        this.setState({
            filter: newFilter,
            asyncSelectedVal: event,
        });
    }

    getFilterArray = () => {
        const listingArr = {};
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt(this.state.totalRecords / this.state.limit + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }

        listingArr.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.order = JSON.stringify(this.state.order);
        listingArr.country_id = this.props.currentCountryId;

        Object.keys(this.state.filter).forEach((val) => {
            listingArr[val] = this.state.filter[val];
        });

        return listingArr;
    }

    refreshHandler = () => {
        this.setState({
            sum_promo_bonus: 0,
            sum_rebate_bonus: 0,
            sum_up_level_bonus: 0,
            sum_vip_weekly_bonus: 0,
            sum_birthday_bonus: 0,
            sum_gold_digger_bonus: 0,
            sum_daily_mission_bonus: 0,
            sum_subtotal: 0,
            sum_rescue_bonus: 0,
            sum_lucky_spin_bonus: 0,
            sum_tournament_bonus: 0,
            sum_voucher_code: 0,
            sum_first_bet_bonus: 0,
            sum_business_account_reward: 0,
            sum_stakings: 0,
            sum_delay_bonus: 0,
            sum_world_cup_event_bonus: 0, 
            sum_member_referral_bonus: 0, 
            sum_agent_payout_bonus: 0, 
            sum_mall_reward_bonus: 0,
            sum_angbao_bonus: 0, 
            sum_mobile_apps_bonus: 0,
            sum_fifa_bonus: 0,
            sum_welcome_bonus: 0,
            sum_daily_bonus: 0,
            sum_accumulate_bonus: 0,
            sum_daily_check_in_bonus: 0,
            sum_instant_rebate_bonus: 0,
            loading: true,
        });

        const listingArr = this.getFilterArray();
        // console.log(listingArr);
        this.props.getMemberPayoutSummaryReport(listingArr);
    }

    searchHandler = () => {
        this.setState({
            loading: true,
            data: [],
            activePage: 1,
        }, () => {
            this.refreshHandler();
        });
    }

    pageChangeHandler = (activePage) => {
        this.setState({page: activePage, activePage: activePage, loading: true, data: []}, () => {
            this.refreshHandler();
        });
    }

    clearHandler = () => {
        let newFilter = initialInputState;
        this.setState({
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            order: '',
            totalRecords: 0,
            loading: true,
            filter: newFilter,
            data: [],
        },() => {
            this.refreshHandler();
        });
    }

    sizePerPageHandler = (limit) => {
        this.setState({
            limit: limit,
            loading: true,
            data: []},
        () => {
            this.refreshHandler();
        });
    }

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({loading: true, data: [], activePage: 1}, () => {
                this.refreshHandler();
            });
        }
    }

    exportExcelHandler = () => {
        Swal.fire({
            // allowOutsideClick: false,
            // allowEscapeKey: false,
            // allowEnterKey: false,
            didOpen: () =>
            {
                Swal.showLoading();
            }
        });

        const data = this.getFilterArray();
        // console.log(data);

        axios.get("report/export_member_payout_summary_report", {
            params: data,
            responseType: "blob",
        }).then((res) => {
            const currentDate = new Date();
            const timestamp = moment(currentDate).format("YYMMDD HHmmss");
            const merchantSlug = process.env.REACT_APP_MERCHANT_SLUG;
            let fileName = `${merchantSlug} Report - Member Payout Summary ${timestamp}`;
            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
            const aElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            aElement.href = href;
            aElement.download = fileName;
            document.body.appendChild(aElement);
            aElement.click();
            document.body.removeChild(aElement);
            window.URL.revokeObjectURL(href);
            Swal.close();
        })
        .catch((err) => {
            console.log("Excel - MemberPayoutSummaryReport Error", err);
        });
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence;

        if (order === "asc") {
            orderSequence = true
        } else {
            orderSequence = false
        }

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({order: orderArry, loading: true, data: []}, () => {
            this.refreshHandler();
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber =
        (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit))
        return <span>{rowNumber}</span>;
    }

    footerFormatter (column, colIndex, {text}) {
        return (
            <div>
                <p className='sub-total'>{column["footer"][0]}</p>
                <p>( {column["footer"][1]} )</p>
            </div>
        );
    }

    render() {
        const { t } = this.props;
        const num_format = {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        };

        // let page_total_promo_bonus = 0;
        let page_total_rebate_bonus = 0;
        let page_total_up_level_bonus = 0;
        let page_total_vip_weekly_bonus = 0;
        let page_total_birthday_bonus = 0;
        let page_total_gold_digger_bonus = 0;
        let page_total_daily_mission_bonus = 0;
        let page_subtotal = 0;
        let page_total_rescue_bonus = 0;
        let page_total_lucky_spin_bonus = 0;
        let page_total_tournament_bonus = 0;
        let page_total_voucher_code = 0;
        let page_total_first_bet_bonus = 0;
        let page_total_business_account_reward = 0;
        let page_total_stakings = 0;
        let page_total_delay_bonus = 0;
        let page_total_fifa_bonus = 0;
        let page_total_member_referral_bonus = 0;
        let page_total_agent_payout_bonus = 0;
        let page_total_mall_reward_bonus = 0;
        let page_total_world_cup_event_bonus = 0;
        let page_total_angbao_bonus = 0;
        let page_total_mobile_apps_bonus = 0;
        let page_total_daily_bonus = 0;
        let page_total_welcome_bonus = 0;
        let page_total_accumulate_bonus = 0;
        let page_total_daily_check_in_bonus = 0;
        let page_total_instant_rebate_bonus = 0;

        this.state.data.forEach((val,idx) => {
            // page_total_promo_bonus += parseFloat(val.total_promo_bonus!==null ? val.total_promo_bonus : 0);
            page_total_rebate_bonus += parseFloat(val.total_rebate_bonus!==null ? val.total_rebate_bonus : 0);
            page_total_up_level_bonus += parseFloat(val.total_up_level_bonus!==null ? val.total_up_level_bonus: 0);
            page_total_vip_weekly_bonus += parseFloat(val.total_vip_weekly_bonus!==null ? val.total_vip_weekly_bonus : 0);
            page_total_birthday_bonus += parseFloat(val.total_birthday_bonus!==null ? val.total_birthday_bonus : 0);
            page_total_gold_digger_bonus += parseFloat(val.total_gold_digger_bonus!==null ? val.total_gold_digger_bonus : 0);
            page_total_daily_mission_bonus += parseFloat(val.total_daily_mission_bonus!==null ? val.total_daily_mission_bonus : 0);
            page_subtotal += parseFloat(val.subtotal!==null ? val.subtotal : 0);
            page_total_rescue_bonus += parseFloat(val.total_rescue_bonus!==null ? val.total_rescue_bonus : 0);
            page_total_lucky_spin_bonus += parseFloat(val.total_lucky_spin_bonus!==null ? val.total_lucky_spin_bonus : 0);
            page_total_tournament_bonus += parseFloat(val.total_tournament_bonus!==null ? val.total_tournament_bonus : 0);
            page_total_voucher_code += parseFloat(val.total_voucher_code!==null ? val.total_voucher_code : 0);
            page_total_first_bet_bonus += parseFloat(val.total_first_bet_bonus!==null ? val.total_first_bet_bonus : 0);
            page_total_business_account_reward += parseFloat(val.total_business_account_reward!==null ? val.total_business_account_reward : 0);
            page_total_stakings += parseFloat(val.total_stakings!==null ? val.total_stakings : 0);
            page_total_delay_bonus += parseFloat(val.total_delay_bonus!==null ? val.total_delay_bonus: 0);
            page_total_fifa_bonus += parseFloat(val.total_fifa_bonus!==null ? val.total_fifa_bonus: 0);
            page_total_member_referral_bonus += parseFloat(val.total_member_referral_bonus!==null ? val.total_member_referral_bonus: 0);
            page_total_agent_payout_bonus += parseFloat(val.total_agent_payout_bonus!==null ? val.total_agent_payout_bonus: 0);
            page_total_mall_reward_bonus += parseFloat(val.total_mall_reward_bonus!==null ? val.total_mall_reward_bonus: 0);
            page_total_world_cup_event_bonus += parseFloat(val.total_world_cup_event_bonus!==null ? val.total_world_cup_event_bonus: 0);
            page_total_angbao_bonus += parseFloat(val.total_angbao_bonus!==null ? val.total_angbao_bonus: 0);
            page_total_mobile_apps_bonus += parseFloat(val.total_mobile_apps_bonus!==null ? val.total_mobile_apps_bonus: 0);
            page_total_welcome_bonus += parseFloat(val.total_welcome_bonus!==null ? val.total_welcome_bonus: 0);
            page_total_daily_bonus += parseFloat(val.total_daily_bonus!==null ? val.total_daily_bonus: 0);
            page_total_accumulate_bonus += parseFloat(val.total_accumulate_bonus!==null ? val.total_accumulate_bonus: 0);
            page_total_daily_check_in_bonus += parseFloat(val.total_daily_check_in_bonus!==null ? val.total_daily_check_in_bonus: 0);
            page_total_instant_rebate_bonus += parseFloat(val.total_instant_rebate_bonus!==null ? val.total_instant_rebate_bonus: 0);
        });

        const columns = [
            {
                text: t('report.date'),
                dataField: "date",
                // keyField: "no",
                // formatter: (cell, row, rowIndex) => {
                //     let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit));
                //     return <span>{rowNumber}</span>;
                // },
                headerStyle: () => {
                    return {width: '90.5px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [t("global.sub-total"),t("global.total")],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("report.welcome"),
                dataField: "total_welcome_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_welcome_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_welcome_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_welcome_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("report.accumulate"),
                dataField: "total_accumulate_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_accumulate_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_accumulate_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_accumulate_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("report.daily"),
                dataField: "total_daily_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_daily_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_daily_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_daily_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.rebate"),
                dataField: "total_rebate_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_rebate_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_rebate_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_rebate_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.fifa"),
                dataField: "total_fifa_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_fifa_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_fifa_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_fifa_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.rescue-bonus"),
                dataField: "total_rescue_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_rescue_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_rescue_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_rescue_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.first-bet-bonus"),
                dataField: "total_first_bet_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_first_bet_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_first_bet_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_first_bet_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("member-group.up-level-bonus"),
                dataField: "total_up_level_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_up_level_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_up_level_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_up_level_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.member-referral"),
                dataField: "total_member_referral_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_member_referral_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_member_referral_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_member_referral_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.birthday-bonus"),
                dataField: "total_birthday_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_birthday_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_birthday_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_birthday_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.vip-weekly-bonus"),
                dataField: "total_vip_weekly_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_vip_weekly_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_vip_weekly_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_vip_weekly_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.stakings"),
                dataField: "total_stakings",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_stakings);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_stakings).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_stakings).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.business-account-reward"),
                dataField: "total_business_account_reward",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_business_account_reward);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_business_account_reward).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_business_account_reward).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.gold-digger-bonus"),
                dataField: "total_gold_digger_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_gold_digger_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_gold_digger_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_gold_digger_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.lucky-spin-bonus"),
                dataField: "total_lucky_spin_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_lucky_spin_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_lucky_spin_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_lucky_spin_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.daily-mission"),
                dataField: "total_daily_mission_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_daily_mission_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_daily_mission_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_daily_mission_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },      
            {
                text: t("transaction-type.agent-payout"),
                dataField: "total_agent_payout_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_agent_payout_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_agent_payout_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_agent_payout_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },  
            {
                text: t("transaction-type.mall-reward-bonus"),
                dataField: "total_mall_reward_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_mall_reward_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_mall_reward_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_mall_reward_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            }, 
            {
                text: t("transaction-type.world-cup-event"),
                dataField: "total_world_cup_event_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_world_cup_event_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_world_cup_event_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_world_cup_event_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },   
            {
                text: t("transaction-type.tournament-bonus"),
                dataField: "total_tournament_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_tournament_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_tournament_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_tournament_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.angbao-bonus"),
                dataField: "total_angbao_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_angbao_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_angbao_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_angbao_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.voucher-code"),
                dataField: "total_voucher_code",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_voucher_code);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_voucher_code).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_voucher_code).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.mobile-apps-bonus"),
                dataField: "total_mobile_apps_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_mobile_apps_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_mobile_apps_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_mobile_apps_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.delay-bonus"),
                dataField: "total_delay_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_delay_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_delay_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_delay_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.daily-check-in"),
                dataField: "total_daily_check_in_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_daily_check_in_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_daily_check_in_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_daily_check_in_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("transaction-type.instant-rebate"),
                dataField: "total_instant_rebate_bonus",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.total_instant_rebate_bonus);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_total_instant_rebate_bonus).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_instant_rebate_bonus).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
            {
                text: t("global.total"),
                dataField: "subtotal",
                formatter: (cell, row, rowIndex) =>
                {
                    return new Intl.NumberFormat("en-US", num_format).format(row.subtotal);
                },
                headerStyle: () => {
                    return {width: '150px'};
                },
                sort: true,
                onSort: this.onSort,
                footer: [
                    new Intl.NumberFormat("en-US", num_format).format(page_subtotal).toString(),
                    new Intl.NumberFormat("en-US", num_format).format(this.state.sum_subtotal).toString()
                ],
                footerFormatter: this.footerFormatter,
                footerClasses: 'table-footer'
            },
        ];

        return (
            <Auxiliary>
                {this.state.pageShow === 'listing' &&
                    <MemberPayoutReportSummaryListing

                        columns={columns}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        data={this.state.data}

                        searchHandler={this.searchHandler}
                        pageChangeHandler={this.pageChangeHandler}
                        clearHandler={() => this.clearHandler()}
                        sizePerPageHandler={this.sizePerPageHandler}
                        searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                        exportExcelHandler={(() => this.exportExcelHandler())}
                        onInputChangeAsync={(event, id) => this.onInputChangeAsync(event, id)}

                        loading={this.state.loading}
                        permission={this.state.permission}
                        filter={this.state.filter}
                        onInputChange={(event, picker) => this.onInputChange(event, picker)}

                        {...this.state}
                    />
                }
            </Auxiliary>
        )
    }
};

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    return {
        reportData: state.report.get_member_payout_summary_report_data,
        currentCountryId: state.currentUser.data.country_id,
        currentPermission: state.currentUser.data.permission,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMemberPayoutSummaryReport: (filter) => dispatch(getMemberPayoutSummaryReport(filter)),
        getFilterData: () => dispatch(getFilterData()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(MemberPayoutSummaryReport));
